export const SUBMIT_SCREENING = 'SubmitScreening';
export const DISABLED_SUBMIT_SCREENING = 'DisabledSubmitScreening';
export const SUBMITTED = 'Submitted';
export const DEFAULT = 'Default';
export const LOADING = 'Loading';
export const SCREENING_COMPLETE = 'ScreeningComplete';
export const EMPLOYER_HISTORY_MODAL = 'EmployerHistoryModal';
export const EMPLOYER_PAYSTUB_MODAL = 'EmployerPaystubModal';
